module.exports = __webpack_public_path__ + "img/ecom-perekprestok-vprok.779a1493.png";